import { toString30pk9tzaqopn as toString } from './Library.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.bf_1 = first;
        this.cf_1 = second;
      }
      toString() {
        return '(' + toString(this.bf_1) + ', ' + toString(this.cf_1) + ')';
      }
      df() {
        return this.bf_1;
      }
      ef() {
        return this.cf_1;
      }
      eu(first, second) {
        return new (Pair())(first, second);
      }
      fu(first, second, $super) {
        first = first === VOID ? this.bf_1 : first;
        second = second === VOID ? this.cf_1 : second;
        return $super === VOID ? this.eu(first, second) : $super.eu.call(this, first, second);
      }
      hashCode() {
        var result = this.bf_1 == null ? 0 : hashCode(this.bf_1);
        result = imul(result, 31) + (this.cf_1 == null ? 0 : hashCode(this.cf_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.bf_1, other.bf_1))
          return false;
        if (!equals(this.cf_1, other.cf_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.gu_1 = first;
        this.hu_1 = second;
        this.iu_1 = third;
      }
      toString() {
        return '(' + toString(this.gu_1) + ', ' + toString(this.hu_1) + ', ' + toString(this.iu_1) + ')';
      }
      hashCode() {
        var result = this.gu_1 == null ? 0 : hashCode(this.gu_1);
        result = imul(result, 31) + (this.hu_1 == null ? 0 : hashCode(this.hu_1)) | 0;
        result = imul(result, 31) + (this.iu_1 == null ? 0 : hashCode(this.iu_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.gu_1, other.gu_1))
          return false;
        if (!equals(this.hu_1, other.hu_1))
          return false;
        if (!equals(this.iu_1, other.iu_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
